module.exports = __webpack_public_path__ + "img/2.4cd3720f.png";